import React from 'react'

// Feature #384 (Epic #381): shown in place of any page whose module is
// switched off in this environment (Settings › Apps). Deliberately plain —
// it is not an error and not a permissions problem, so it borrows the
// NotFoundPage layout rather than the toast/alert styling.
const ModuleUnavailable: React.FC<{ moduleName: string }> = ({ moduleName }) => (
  <div style={{ textAlign: 'center', paddingTop: '60px' }}>
    <h1 style={{ fontSize: '32px', fontWeight: 600, color: 'var(--color-black)', marginBottom: '16px' }}>
      {moduleName} is not available
    </h1>
    <p style={{ color: 'var(--color-dark-grey)', marginBottom: '32px' }}>
      This module is switched off in this environment.
    </p>
    <a
      href="/"
      style={{
        display: 'inline-block',
        padding: '10px 20px',
        backgroundColor: 'var(--color-magenta)',
        color: 'var(--color-white)',
        textDecoration: 'none',
        borderRadius: '6px',
        fontWeight: 500,
      }}
    >
      Back home
    </a>
  </div>
)

export default ModuleUnavailable
